import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore, selectIsAuthed, selectIsSuperAdmin } from "../../store/auth.store.js";

/**
 * Auth gate for the admin routes. If not authed → redirect to /login carrying
 * the intended path so we can bounce back after a successful login.
 *
 * `superAdminOnly` adds a second gate for the Settings/Users/Activity pages.
 * Server-side enforcement is the source of truth; this just hides the UI.
 */
export function ProtectedRoute({ superAdminOnly = false }) {
  const location = useLocation();
  const authed = useAuthStore(selectIsAuthed);
  const isSuperAdmin = useAuthStore(selectIsSuperAdmin);

  if (!authed) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (superAdminOnly && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
